import { useEffect } from "react";

import { isDevReactEnv } from "../Utils/constants";

export const SYNCTERA_ENV = isDevReactEnv ? "sandbox" : "production";

const WIDGET_SCRIPTS = [
  {
    id: "synctera-reveal-card",
    src: `https://assets${isDevReactEnv ? "-sandbox" : ""}.synctera.com/widgets/reveal-card/v1.1.0/index.js`,
  },
  {
    id: "synctera-set-pin",
    src: `https://assets${isDevReactEnv ? "-sandbox" : ""}.synctera.com/widgets/set-pin/v1.1.0/index.js`,
  },
  {
    id: "synctera-activate-card",
    src: `https://assets${isDevReactEnv ? "-sandbox" : ""}.synctera.com/widgets/activate/v1.1.0/index.js`,
  },
];

export function useSyncteraWidgetScripts() {
  useEffect(() => {
    const added = [];
    WIDGET_SCRIPTS.forEach(({ id, src }) => {
      if (document.getElementById(id)) return;
      const s = document.createElement("script");
      s.id = id;
      s.type = "module";
      s.src = src;
      document.head.appendChild(s);
      added.push(s);
    });
    return () => added.forEach((s) => s.parentNode && s.parentNode.removeChild(s));
  }, []);
}

export function readSyncteraBrandStyles({ variant = "form" } = {}) {
  if (typeof window === "undefined") return "{}";
  const css = getComputedStyle(document.documentElement);
  const v = (name, fallback) => (css.getPropertyValue(name) || "").trim() || fallback;
  const mist = v("--mist", "#f4fdfa");
  const accent = v("--accent", "#54FF99");
  const accentHover = v("--accent-hover", "#3BD87A");
  const charcoal = v("--charcoal", "#212737");
  const bgPrimary = v("--bg-primary", "#212737");
  const bgSecondary = v("--bg-secondary", "#252A3A");
  const borderColor = v("--border-color", "#3a3f4f");

  const isReveal = variant === "reveal";
  const labelColor = isReveal ? charcoal : mist;
  const titleColor = isReveal ? charcoal : mist;
  const textColor = isReveal ? charcoal : mist;

  const tokens = {
    // Tier 1 — Core
    fontFamily: v("--font-family", "Inter, sans-serif"),
    primaryColor: accent,
    primaryColorHover: accentHover,
    textColor,
    textColorSecondary: "rgba(244, 253, 250, 0.6)",
    backgroundColor: bgPrimary,
    inputBackground: bgSecondary,
    inputBorderColor: borderColor,
    inputBorderRadius: "8px",
    borderRadius: "12px",
    errorColor: v("--error-red", "#ff6b6b"),
    successColor: v("--success-green", "#54FF99"),

    // Tier 2 — Component overrides
    buttonBackground: accent,
    buttonTextColor: charcoal,
    buttonBorderRadius: "12px",
    inputTextColor: mist,
    inputFocusBorderColor: accent,
    inputFontSize: "15px",
    labelColor,
    labelFontSize: "14px",
    titleColor,
    titleFontSize: "18px",

    // Reveal Card only
    cardBackground: "linear-gradient(135deg, #2A7F52 0%, #54FF99 100%)",
    cardTextColor: "#ffffff",
    cardBorderRadius: "16px",
  };
  return JSON.stringify(tokens);
}
